import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  Select,
  Text,
} from "@chakra-ui/react";
import { GRAY, VARIANT, WHITE } from "../constants/colors";
import "react-credit-cards-2/es/styles-compiled.css";
import Cards from "react-credit-cards-2";
import { useEffect, useState } from "react";
import { PatternFormat } from "react-number-format";
import { stateOptions } from "../constants/stateOptions";
import moment from "moment";
import { dateForAPI, dateForValueInput } from "../constants/dataFormat";
import useScript from "./helpers/useScript";
import { toast } from "react-toastify";
import ModalPaymentConfirmation from "./components/ModalPaymentConfirmation";
import axios from "axios";
import { baseURL } from "../services/api";
import TitleFlex from "../pages/vendas/vendasBoleto/components/titleFlex";
import { parcelasvendaDigitada } from "../pages/vendas/vendasDigitadas/defaultComponents/parcelas";
import VendasDigitadasApi from "../services/vendasDigitadasApi";

export default function CardPayment() {
  useScript(
    null,
    `(function (a, b, c, d, e, f, g) {
    a['CsdpObject'] = e; a[e] = a[e] ||  function () {
    (a[e].q = a[e].q || []).push(arguments)
  }, a[e].l = 1 * new Date(); f = b.createElement(c),
  g = b.getElementsByTagName(c)[0]; f.async = 1; f.src = d; g.parentNode.insertBefore(f, g)
})(window, document, 'script', 'https://device.clearsale.com.br/p/fp.js', 'csdp');
  csdp('app', '7gaq6iqa70lrxje431t6');
  csdp('outputsessionid', 'sessionId');`
  );

  const initialState = {
    numeroCartao: "",
    nomePagador: "",
    validadeMes: "",
    validadeAno: "",
    cvv: "",
    ip: "",
    sessionID: "",
    bandeira: "",
    parcelas: 0,
    cpfPagador: "",
    telefonePagador: "",
    dataNascPagador: "",
    enderCEP: "",
    enderRua: "",
    enderNumero: "",
    enderComplemento: "",
    enderReferencia: "",
    enderBairro: "",
    enderCidade: "",
    enderEstado: "AC",
  };

  const [objeto, setObjeto] = useState(initialState);

  const unMask = (value) => {
    return value.replace(/[^0-9]/g, "");
  };

  const [focused, setFocused] = useState("");

  function onSubmit() {
    const sessionID = document.getElementById("sessionId").value;

    const ForAPI = {
      numeroCartao: unMask(objeto.numeroCartao),
      nomePagador: objeto.nomePagador,
      validadeMes: objeto.validadeMes,
      validadeAno: objeto.validadeAno,
      cvv: objeto.cvv,
      sessionID: sessionID,
      bandeira: objeto.bandeira,
      parcelas: Number(objeto.parcelas),
      cpfPagador: unMask(objeto.cpfPagador),
      telefonePagador: unMask(objeto.telefonePagador),
      dataNascPagador: objeto.dataNascPagador,
      enderCEP: unMask(objeto.enderCEP),
      enderRua: objeto.enderRua,
      enderNumero: objeto.enderNumero,
      enderComplemento: objeto.enderComplemento,
      enderReferencia: objeto.enderReferencia,
      enderBairro: objeto.enderBairro,
      enderCidade: objeto.enderCidade,
      enderEstado: objeto.enderEstado,
    };
    // console.log("objeto de pagamento", ForAPI);
    postVenda(ForAPI);
  }
  const [isOpen, setIsOpen] = useState(false);

  async function postVenda(obj) {
    try {
      const response = await VendasDigitadasApi.postPayment(token, obj);
      console.log("response do postVenda", response);
      setIsOpen(true);
    } catch (error) {
      setIsOpen(false);
      toast.error(
        "Não foi possível realizar o pagamento. Entre em contato com o suporte!"
      );
    }
  }

  function onFocus(e) {
    setFocused(e.target.name);
  }

  function handleCallback({ issuer }, isValid) {
    if (isValid) {
      setObjeto({ ...objeto, bandeira: issuer });
    }
  }

  const token = window.location.search.slice(7);

  const [pagador, setpagador] = useState();

  async function getVendaDigitadaPerToken() {
    try {
      const response = await axios.get(
        `${baseURL}/buscarVenda-digitada/token?token=${token}`
      );
      console.log("response do token", response.data);
      setpagador(response.data);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getVendaDigitadaPerToken();
  }, []);

  return (
    <Flex
      w={"99.97vw"}
      h={"99.7vh"}
      bgColor={GRAY}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Flex
        w={"70vw"}
        h={"97vh"}
        bgColor={WHITE}
        borderRadius={"20px"}
        flexDir={"column"}
        overflowY={"scroll"}
        overflowX={"hidden"}
      >
        <Flex w={"100%"} h={"8%"} justifyContent={"center"}>
          <Image src={"./logo.png"} />
        </Flex>
        <Flex
          w={"70vw"}
          h={"70%"}
          flexDir={"row"}
          justifyContent={"space-evenly"}
        >
          <Flex w={"42vw"} h={"88vh"} flexDir={"column"}>
            <Flex
              w={"42vw"}
              h={"23vh"}
              maxH={"23vh"}
              flexDir={"row"}
              justifyContent={"space-evenly"}
              mb={2}
            >
              <Flex w={"294px"} h={"190px"} alignItems={"center"} mr={2}>
                <Cards
                  preview
                  cvc={objeto.cvv}
                  expiry={`${objeto.validadeMes}/${objeto.validadeAno}`}
                  focused={focused}
                  name={objeto.nomePagador}
                  callback={handleCallback}
                  number={objeto.numeroCartao}
                  style={{}}
                  placeholders={{
                    name: "Nome do titular",
                  }}
                  locale={{
                    valid: "Válido até",
                  }}
                />
                <Input type="hidden" id="sessionId" />
              </Flex>
              <Flex
                w={"60%"}
                maxWidth={"60%"}
                h={"100%"}
                px={1}
                flexDir={"column"}
              >
                <FormControl w={"100%"} h={"8vh"}>
                  <FormLabel fontSize={"13px"} mb={0}>
                    Número do Cartão
                  </FormLabel>
                  <PatternFormat
                    customInput={Input}
                    name={"number"}
                    format={"#### #### #### ####"}
                    placeholder={"Número do Cartão de Crédito"}
                    value={objeto.numeroCartao}
                    onChange={(e) => {
                      setObjeto({ ...objeto, numeroCartao: e.target.value });
                    }}
                    onFocus={onFocus}
                  />
                </FormControl>
                <FormControl w={"100%"} h={"8vh"} mt={1}>
                  <FormLabel fontSize={"13px"} mb={0}>
                    Nome do Titular
                  </FormLabel>
                  <Input
                    placeholder={"Digite o nome do titular"}
                    name={"name"}
                    onChange={(e) => {
                      setObjeto({ ...objeto, nomePagador: e.target.value });
                    }}
                    onFocus={onFocus}
                  />
                </FormControl>
                <Flex flexDir={"row"} mt={1}>
                  <FormControl w={"100%"} h={"8vh"}>
                    <FormLabel fontSize={"13px"} mb={0}>
                      Validade
                    </FormLabel>
                    <Flex flexDir={"row"}>
                      <Input
                        placeholder="MM"
                        mx={1}
                        name={"expiry"}
                        maxLength={2}
                        onChange={(e) => {
                          setObjeto({ ...objeto, validadeMes: e.target.value });
                        }}
                        onFocus={onFocus}
                      />
                      <Input
                        placeholder="YYYY"
                        mx={1}
                        name={"expiry"}
                        maxLength={4}
                        onChange={(e) => {
                          setObjeto({ ...objeto, validadeAno: e.target.value });
                        }}
                        onFocus={onFocus}
                      />
                    </Flex>
                  </FormControl>
                  <FormControl w={"100%"} h={"8vh"}>
                    <FormLabel fontSize={"13px"} mb={0}>
                      CVV
                    </FormLabel>
                    <Input
                      placeholder="123"
                      mx={1}
                      name={"cvc"}
                      type={"text"}
                      maxLength={4}
                      onChange={(e) => {
                        setObjeto({ ...objeto, cvv: e.target.value });
                      }}
                      onFocus={onFocus}
                    />
                  </FormControl>
                </Flex>
              </Flex>
            </Flex>
            <TitleFlex item={"Parcelamento"} />
            <FormControl>
              <Select
                onChange={(e) => {
                  setObjeto({ ...objeto, parcelas: e.target.value });
                }}
              >
                {parcelasvendaDigitada.map((item) => {
                  return (
                    <option value={item.value} key={item.key}>
                      {item.text}
                    </option>
                  );
                })}
              </Select>
            </FormControl>
            <TitleFlex item={"Dados do Titular do Cartão"} />
            <Flex flexDir={"row"}>
              <FormControl mx={2}>
                <FormLabel fontSize={"13px"} mb={0}>
                  CPF/CNPJ do pagador
                </FormLabel>
                <PatternFormat
                  customInput={Input}
                  format={
                    unMask(objeto.cpfPagador).length === 11
                      ? "###.###.###-#####"
                      : "##.###.###/####-##"
                  }
                  type="text"
                  placeholder="Digite o CPF ou CNPJ"
                  value={objeto.cpfPagador}
                  onChange={(e) => {
                    setObjeto({ ...objeto, cpfPagador: e.target.value });
                  }}
                />
              </FormControl>
              <FormControl mx={2}>
                <FormLabel fontSize={"13px"} mb={0}>
                  Telefone
                </FormLabel>
                <PatternFormat
                  customInput={Input}
                  format={"(##) #####-####"}
                  type="tel"
                  placeholder="Digite o telefone "
                  value={objeto.telefonePagador}
                  onChange={(e) => {
                    setObjeto({ ...objeto, telefonePagador: e.target.value });
                  }}
                />
              </FormControl>
              <FormControl mx={2}>
                <FormLabel fontSize={"13px"} mb={0}>
                  Data de Nascimento
                </FormLabel>
                <Input
                  type={"date"}
                  value={moment(objeto.dataNascPagador).format(
                    dateForValueInput
                  )}
                  onChange={(e) => {
                    setObjeto({
                      ...objeto,
                      dataNascPagador: moment(e.target.value).format(
                        dateForAPI
                      ),
                    });
                  }}
                />
              </FormControl>
            </Flex>
            <TitleFlex item={"Endereço de Cobrança"} />
            <Flex flexDir={"row"}>
              <FormControl mx={2} maxW={"18%"} mt={1}>
                <FormLabel fontSize={"13px"} mb={0}>
                  CEP
                </FormLabel>
                <PatternFormat
                  customInput={Input}
                  format={"#####-###"}
                  value={objeto.enderCEP}
                  onChange={(e) => {
                    setObjeto({ ...objeto, enderCEP: e.target.value });
                  }}
                />
              </FormControl>
              <FormControl mx={2} mt={1}>
                <FormLabel fontSize={"13px"} mb={0}>
                  Endereço
                </FormLabel>
                <Input
                  type={"text"}
                  value={objeto.enderRua}
                  onChange={(e) => {
                    setObjeto({ ...objeto, enderRua: e.target.value });
                  }}
                />
              </FormControl>
            </Flex>
            <Flex flexDir={"row"} mt={1}>
              <FormControl mx={2} maxW={"20%"}>
                <FormLabel fontSize={"13px"} mb={0}>
                  N°
                </FormLabel>
                <Input
                  type={"text"}
                  value={objeto.enderNumero}
                  onChange={(e) => {
                    setObjeto({ ...objeto, enderNumero: e.target.value });
                  }}
                />
              </FormControl>
              <FormControl mx={2}>
                <FormLabel fontSize={"13px"} mb={0}>
                  Complemento
                </FormLabel>
                <Input
                  type={"text"}
                  value={objeto.enderComplemento}
                  onChange={(e) => {
                    setObjeto({ ...objeto, enderComplemento: e.target.value });
                  }}
                />
              </FormControl>
            </Flex>
            <Flex flexDir={"row"} mt={1}>
              <FormControl mx={2} maxW={"35%"}>
                <FormLabel fontSize={"13px"} mb={0}>
                  Referência
                </FormLabel>
                <Input
                  type={"text"}
                  value={objeto.enderReferencia}
                  onChange={(e) => {
                    setObjeto({ ...objeto, enderReferencia: e.target.value });
                  }}
                />
              </FormControl>
              <FormControl mx={2}>
                <FormLabel fontSize={"13px"} mb={0}>
                  Bairro
                </FormLabel>
                <Input
                  type={"text"}
                  value={objeto.enderBairro}
                  onChange={(e) => {
                    setObjeto({ ...objeto, enderBairro: e.target.value });
                  }}
                />
              </FormControl>
            </Flex>
            <Flex flexDir={"row"} mt={1}>
              <FormControl mx={2}>
                <FormLabel fontSize={"13px"} mb={0}>
                  Cidade
                </FormLabel>
                <Input
                  type={"text"}
                  value={objeto.enderCidade}
                  onChange={(e) => {
                    setObjeto({ ...objeto, enderCidade: e.target.value });
                  }}
                />
              </FormControl>
              <FormControl mx={2} maxW={"35%"}>
                <FormLabel fontSize={"13px"} mb={0}>
                  Estado
                </FormLabel>
                <Select
                  value={objeto.enderEstado}
                  onChange={(e) => {
                    setObjeto({ ...objeto, enderEstado: e.target.value });
                  }}
                >
                  {stateOptions.map((item, index) => {
                    return (
                      <option value={item.value} key={index}>
                        {item.text}
                      </option>
                    );
                  })}
                </Select>
              </FormControl>
            </Flex>
            <Flex justifyContent={"center"} w={"100%"}>
              <Button
                bgColor={VARIANT}
                color={WHITE}
                mt={4}
                w={"600px"}
                onClick={() => {
                  onSubmit();
                }}
              >
                Efetuar Pagamento
              </Button>
            </Flex>
          </Flex>
          <Flex
            w={"35%"}
            maxWidth={"35%"}
            h={"95%"}
            borderLeft={`solid 4px ${VARIANT}`}
            flexDir={"column"}
          >
            <TitleFlex item={"Cliente"} />
            <Flex flexDir={"column"} px={4}>
              <Text fontWeight={"bold"}>{pagador && pagador.nomePagador}</Text>
              <Text>{pagador && pagador.emailPagador}</Text>
            </Flex>
            <TitleFlex item={"Detalhes da Compra"} />
            {pagador && pagador.itens ? (
              pagador.itens.map((item, index) => {
                return (
                  <Flex
                    flexDir={"row"}
                    px={6}
                    key={index}
                    my={2}
                    justifyContent={"space-between"}
                  >
                    <Flex flexDir={"column"} w={"80%"}>
                      <Text fontWeight={"bold"}>
                        {item.codigo != ""
                          ? `${item.codigo} - ${item.descricao}`
                          : item.descricao}
                      </Text>
                      <Text>{`Quantidade : ${item.quantidade}`}</Text>
                      <Text>{`Valor do Item : ${item.valorItem.toLocaleString(
                        "pt-BR",
                        {
                          style: "currency",
                          currency: "BRL",
                        }
                      )}`}</Text>
                    </Flex>
                    <Flex alignItems={"center"}>
                      <Text
                        fontWeight={"bold"}
                        fontSize={"20px"}
                        color={VARIANT}
                      >
                        {item.valorTotalItem.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                      </Text>
                    </Flex>
                  </Flex>
                );
              })
            ) : (
              <></>
            )}
            <TitleFlex item={"Total"} />
            <Flex justifyContent={"flex-end"} px={4}>
              <Text fontWeight={"bold"} fontSize={"24px"} color={VARIANT}>
                {pagador &&
                  pagador.valorTotal.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <ModalPaymentConfirmation isOpen={isOpen} setIsOpen={setIsOpen} />
      </Flex>
    </Flex>
  );
}
